import { render } from "./LinkDesktop.vue?vue&type=template&id=012fff06&scoped=true"
import script from "./LinkDesktop.vue?vue&type=script&lang=js"
export * from "./LinkDesktop.vue?vue&type=script&lang=js"

import "./LinkDesktop.vue?vue&type=style&index=0&id=012fff06&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-012fff06"]])

export default __exports__